import { genericPost, genericFilePost, genericDelete, genericPut, genericGet } from './apiService';
import { API_URL } from '../config/env';

/**
 * Chat isteği gönder
 * @param {Object} req - İstek parametreleri
 */
export const ChatRequest = async (req) => {
  try {
    const response = await genericPost(`${API_URL}Chat/ChatRequest`, req);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * İlanları filtrele ve listele (loginsiz public + girişli private)
 * @param {Object} params - Filtreleme parametreleri
 * @param {boolean} [forcePublic] - true ise her zaman public endpoint
 */
const normalizeFilters = (filters) => {
  if (!Array.isArray(filters)) return [];
  return filters
    .filter((f) => f && (f.propertyName || f.PropertyName))
    .map((f) => ({
      propertyName: f.propertyName ?? f.PropertyName,
      operation: f.operation ?? f.Operation ?? '==',
      value:
        f.value === null || f.value === undefined
          ? ''
          : String(f.value ?? f.Value),
    }));
};

export const Getlist = async (params, forcePublic = false) => {
  try {
    const requestData = {
      filters: normalizeFilters(params.filters),
      sortBy: params.sortBy || 'CreatedDate',
      sortOrder: params.sortOrder || 'desc',
      pageIndex: params.pageIndex || 1,
      pageSize: params.pageSize || 12
    };

    const hasToken = !!localStorage.getItem('authToken');
    const usePublic = forcePublic || !hasToken;
    const endpoint = usePublic ? 'Roommate/GetFilterPublic' : 'Roommate/GetFilter';

    const response = await genericPost(`${API_URL}${endpoint}`, requestData);
    return response;
  } catch (error) {
    console.error('Error fetching listings:', error);
    
    return {
      data: {
        items: [],
        totalPages: 0,
        totalCount: 0
      }
    };
  }
};

/**
 * Favori ilanları filtrele ve listele
 * @param {Object} filter - Filtreleme parametreleri
 */
export const GetFilterFavorite = async (filter) => {
  try {
    const response = await genericPost(`${API_URL}Roommate/GetFilterFavorite`, filter);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Kullanıcının ilanlarını filtrele ve listele
 * @param {Object} filter - Filtreleme parametreleri
 */
export const GetFilterUser = async (filter) => {
  try {
    const response = await genericPost(`${API_URL}Roommate/GetFilterUser`, filter);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Yeni ilan ekle
 * @param {Object} request - İlan bilgileri
 */
export const AddRoommateReq = async (request) => {
  try {
    const response = await genericPost(`${API_URL}Roommate/Add`, request);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * İlan güncelle
 * @param {Object} request - Güncellenecek ilan bilgileri
 */
export const UpdateRoommateReq = async (request) => {
  try {
    const response = await genericPut(`${API_URL}Roommate/Update`, request);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * İlan sil
 * @param {string} id - Silinecek ilan ID
 */
export const DeleteRoommateReq = async (id) => {
  try {
    const response = await genericDelete(`${API_URL}Roommate/Delete?id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * İlana resim ekle
 * @param {Object} request - Resim dosyası
 */
export const AddRoommateImg = async (request) => {
  try {
    const response = await genericFilePost(`${API_URL}Roommate/AddImages`, request);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * İlan resmini sil
 * @param {string} id - Silinecek resim ID
 */
export const DeleteRoommateImg = async (id) => {
  try {
    const response = await genericDelete(`${API_URL}Roommate/DeleteImages?id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Favoriye ekle/çıkar
 * @param {string} uId - İlan ID
 * @param {number} type - 1: Ekle, 0: Çıkar
 */
export const addFav = async (uId, type) => {
  try {
    const response = await genericPost(`${API_URL}Favorite/Add`, {
      uId,
      type
    });
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * İlan detaylarını getir
 * @param {string} id - İlan ID
 */
export const getAdvertById = async (id) => {
  try {
    const hasToken = !!localStorage.getItem('authToken');
    const endpoint = hasToken
      ? `Roommate/GetById?key=${id}`
      : `Roommate/GetByIdPublic?key=${id}`;
    const response = await genericGet(`${API_URL}${endpoint}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const GetRoommateById = async (id) => {
  try {
    const hasToken = !!localStorage.getItem('authToken');
    const endpoint = hasToken
      ? `Roommate/GetById?key=${id}`
      : `Roommate/GetByIdPublic?key=${id}`;
    const response = await genericGet(`${API_URL}${endpoint}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Favorileri getirme
export const GetFavorites = async () => {
  try {
    const response = await genericGet(`${API_URL}Roommate/GetFavorites`);
    return response;
  } catch (error) {
    console.error('Error fetching favorites:', error);
    return { data: [] };
  }
};

// İlan detayını getirme
export const GetDetail = async (id) => {
  try {
    console.log('Fetching detail for ID:', id);
    // Mevcut getAdvertById fonksiyonunu kullan
    const response = await getAdvertById(id);
    console.log('Detail response:', response);
    return response;
  } catch (error) {
    console.error('Error fetching listing detail:', error);
    throw error;
  }
};

// Favori durumunu değiştirme
export const ToggleFavorite = async (id, isFavorite) => {
  try {
    console.log('Toggling favorite for ID:', id, 'isFavorite:', isFavorite);
    // Mevcut addFav fonksiyonunu kullan
    // isFavorite true ise type=0 (çıkar), false ise type=1 (ekle)
    const type = isFavorite ? 0 : 1;
    const response = await addFav(id, type);
    console.log('Toggle favorite response:', response);
    return response;
  } catch (error) {
    console.error('Error toggling favorite:', error);
    throw error;
  }
};

